import React, { useState } from "react";
import {
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@material-ui/core";
import InfoIcon from "@material-ui/icons/Info";

const InfoTooltip = ({ title, content, size = "small" }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleDialogOpen = () => {
    setOpen(true);
  };

  const tooltipContent = (
    <div style={{ maxWidth: 200 }}>
      <Typography variant="body2">{content}</Typography>
    </div>
  );

  return (
    <>
      <Tooltip title={tooltipContent} arrow>
        <IconButton
          size={size}
          onClick={handleDialogOpen}
          style={{ marginLeft: 8, padding: 4 }}
        >
          <InfoIcon style={{ fontSize: 16, color: "#666" }} />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={handleTooltipClose} maxWidth="sm" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Typography variant="body1">{content}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTooltipClose} color="primary">
            Got it
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InfoTooltip;
